import { useQuery, UseQueryResult } from 'react-query';
import { ReservedTotalAmount, UrlParams } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams } from 'utils/functions';

interface IUseTotalReserved {
  athlete?: string;
  events?: string[];
  startDateRange?: string;
  endDateRange?: string;
  enabled?: boolean;
  type?: 'past' | 'upcoming';
}

function useTotalReserved({
  athlete,
  events,
  startDateRange,
  endDateRange,
  enabled = true,
  type,
}: IUseTotalReserved): UseQueryResult<{
  data: ReservedTotalAmount;
}> {
  const params: UrlParams = {};

  if (athlete) {
    params.athlete = athlete;
  }
  if (events && events.length > 0) {
    params.events = events.join(',');
  }
  if (startDateRange !== undefined) {
    params.start_date_range = startDateRange;
  }
  if (endDateRange !== undefined) {
    params.end_date_range = endDateRange;
  }
  if (type !== undefined) {
    params.type = type;
  }
  params.is_reserved = 'True';
  return useQuery(
    ['totalReserved', athlete, events, startDateRange, endDateRange, enabled, type],
    () => client.get(`athlete-events/total-reserved?${encodeUrlParams(params)}`),
    {
      enabled,
    },
  );
}

export default useTotalReserved;
